export default __webpack_public_path__ + "images/violet-30.png";